import React from 'react'
import SpinnerUI from '../output/SpinnerUI'
import './LRTableBody.css'

const LRTableBodyUI = ({context, className, busy, children}) =>
  <div className={`w_lr_tbl ${className ? className : ''}`}>
    <SpinnerUI show={busy} />
    {
      !busy &&
      <React.Fragment>
        {children}
      </React.Fragment>
    }
  </div>

export default LRTableBodyUI
